module.exports = "/images/new-upload.png?f36843546f64662a8227a2dde08c3707";